import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import i18n from '@/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddressValidationStatus',
  props: {
    validated: {
        type: Boolean as PropType<boolean | null>,
        default: null,
    },
    isValidating: {
        type: Boolean,
        default: false,
    },
    isUnavailable: {
        type: Boolean,
        default: false,
    },
},
  emits: ["open-address-in-maps"],
  setup(__props, { emit }: { emit: ({
    (e: 'open-address-in-maps'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;




const isVisible = computed(() => props.isUnavailable || props.isValidating || typeof props.validated === 'boolean');
const canOpenMaps = computed(() => props.validated === true && !props.isValidating && !props.isUnavailable);

function openMaps() {
    if (!canOpenMaps.value) {
        return;
    }

    emit('open-address-in-maps');
}

const status = computed(() => {
    if (props.isUnavailable) {
        return 'unavailable';
    }

    if (props.isValidating) {
        return 'validating';
    }

    return props.validated ? 'valid' : 'invalid';
});

const label = computed(() => {
    if (props.isUnavailable) {
        return i18n.t(
            'Address validation is temporarily unavailable. Enter the address manually — it will be saved normally. Validation will be available again tomorrow.',
        );
    }

    if (props.isValidating) {
        return i18n.t('Validating address');
    }

    return props.validated ? i18n.t('Address validated') : i18n.t('Address needs review');
});

const hint = computed(() => {
    if (props.isUnavailable) {
        return '';
    }

    if (props.isValidating) {
        return i18n.t('Checking Google suggestion service');
    }

    return props.validated
        ? i18n.t('Address confirmed. Click to open google maps with the address')
        : i18n.t('Review the suggestion popup or keep the original value');
});

return { __sfc: true,props, emit, isVisible, canOpenMaps, openMaps, status, label, hint }
}

})